import { core } from '../core/index.js';
import { filterFabricErrors } from '../errors/errors.js';

export type FabricStorageInfoCallbackData = {
  /**
   * 当前 storage 中所有的 key
   */
  keys: string[];
  /**
   * 当前占用的空间大小, 单位 KB
   */
  currentSize: number;
  /**
   * 限制的空间大小，单位 KB
   */
  limitSize: number;
};

export type FabricStorageGetStorageInfoApi =
  () => Promise<FabricStorageInfoCallbackData>;
/**
 * 异步获取当前storage的相关信息
 * @returns Promise<FabricStorageInfoCallbackData>
 */
export const getStorageInfo: FabricStorageGetStorageInfoApi = () => {
  return new Promise<FabricStorageInfoCallbackData>((resolve, reject) => {
    core.call<
      'fabric_storage.getStorageInfo',
      null,
      FabricStorageInfoCallbackData
    >('fabric_storage.getStorageInfo', null, (result) => {
      const fabricErrors = filterFabricErrors(
        result.code,
        result.message,
        result.data
      );
      if (fabricErrors) {
        reject(fabricErrors);
      } else {
        resolve(result.data);
      }
    });
  });
};
